import { USER_TYPE } from '../constants';

const getHeaderKey = (
  i18n: (key: string) => string,
  code: string,
  userType: USER_TYPE,
  isBTRRebrandingFlagOn?: boolean,
): string => {
  const keyPattern = (value: string) => {
    if (isBTRRebrandingFlagOn && userType === USER_TYPE.BUYER && code === 'service-fee-price') {
      return i18n('dlv_returns_details_payment_details_order_buyer_service_fee_price_BTR');
    }
    return i18n(`dlv_returns_details_payment_details_order_${userType}_${value}`);
  };

  return keyPattern(`${code.replace(/-/g, '_')}`);
};

export default getHeaderKey;
